import { render, staticRenderFns } from "./PopupConfirmDeleteArticle.vue?vue&type=template&id=23d8bc74"
import script from "./PopupConfirmDeleteArticle.vue?vue&type=script&lang=js"
export * from "./PopupConfirmDeleteArticle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports